/**
 * @generated SignedSource<<18c7b87a27aef6235f8eb317427a5652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UseProgramTemplateInput = {
  clientMutationId?: string | null | undefined;
  templateId: string;
};
export type CardProgramTemplateMutation$variables = {
  input: UseProgramTemplateInput;
};
export type CardProgramTemplateMutation$data = {
  readonly useProgramTemplate: {
    readonly program: {
      readonly id: string;
      readonly slug: string;
    };
  } | null | undefined;
};
export type CardProgramTemplateMutation = {
  response: CardProgramTemplateMutation$data;
  variables: CardProgramTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UseProgramTemplatePayload",
    "kind": "LinkedField",
    "name": "useProgramTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CardProgramTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CardProgramTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd4a87319a2f6a1833c39b13bcf06937",
    "id": null,
    "metadata": {},
    "name": "CardProgramTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation CardProgramTemplateMutation(\n  $input: UseProgramTemplateInput!\n) {\n  useProgramTemplate(input: $input) {\n    program {\n      id\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "122903aa476b00b45923aac1a18c89e3";

export default node;
